import React from 'react';
import { motion } from 'framer-motion';

const Logo = ({ size = 'md', className = '' }) => {
  const sizeClasses = {
    sm: 'w-8 h-8',
    md: 'w-10 h-10',
    lg: 'w-12 h-12',
    xl: 'w-16 h-16'
  };

  const logoSize = sizeClasses[size] || sizeClasses.md;

  return (
    <motion.div
      className={`${logoSize} ${className}`}
      initial={{ rotate: 0 }}
      whileHover={{ rotate: 5, scale: 1.05 }}
      transition={{ type: "spring", stiffness: 300 }}
    >
      <svg
        viewBox="0 0 100 100"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="w-full h-full"
      >
        {/* Background circle with gradient */}
        <defs>
          <linearGradient id="bgGradient" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#3B82F6" />
            <stop offset="100%" stopColor="#1E40AF" />
          </linearGradient>
          <linearGradient id="cardGradient1" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#EF4444" />
            <stop offset="100%" stopColor="#DC2626" />
          </linearGradient>
          <linearGradient id="cardGradient2" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#EAB308" />
            <stop offset="100%" stopColor="#CA8A04" />
          </linearGradient>
          <linearGradient id="cardGradient3" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#22C55E" />
            <stop offset="100%" stopColor="#16A34A" />
          </linearGradient>
        </defs>
        
        {/* Main background circle */}
        <circle cx="50" cy="50" r="45" fill="url(#bgGradient)" />
        
        {/* Kanban board representation */}
        {/* Left column (Backlog/To Do) */}
        <rect x="15" y="20" width="18" height="25" rx="3" fill="url(#cardGradient1)" opacity="0.9" />
        <rect x="15" y="48" width="18" height="8" rx="2" fill="white" opacity="0.3" />
        <rect x="15" y="59" width="18" height="8" rx="2" fill="white" opacity="0.3" />
        
        {/* Middle column (In Progress) */}
        <rect x="41" y="25" width="18" height="20" rx="3" fill="url(#cardGradient2)" opacity="0.9" />
        <rect x="41" y="48" width="18" height="8" rx="2" fill="white" opacity="0.3" />
        <rect x="41" y="59" width="18" height="8" rx="2" fill="white" opacity="0.3" />
        
        {/* Right column (Done) */}
        <rect x="67" y="30" width="18" height="15" rx="3" fill="url(#cardGradient3)" opacity="0.9" />
        <rect x="67" y="48" width="18" height="8" rx="2" fill="white" opacity="0.3" />
        <rect x="67" y="59" width="18" height="8" rx="2" fill="white" opacity="0.3" />
        
        {/* Animated checkmark on Done column */}
        <motion.path
          d="M72 37 L75 40 L83 32"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          initial={{ pathLength: 0 }}
          animate={{ pathLength: 1 }}
          transition={{ duration: 1, delay: 0.5 }}
        />
        
        {/* Progress arrow */}
        <motion.path
          d="M33 35 L36 35 L34 33 M36 35 L34 37"
          stroke="white"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
          opacity="0.6"
          initial={{ opacity: 0, x: -5 }}
          animate={{ opacity: 0.6, x: 0 }}
          transition={{ duration: 0.5, delay: 0.3 }}
        />
        
        <motion.path
          d="M59 35 L62 35 L60 33 M62 35 L60 37"
          stroke="white"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
          opacity="0.6"
          initial={{ opacity: 0, x: -5 }}
          animate={{ opacity: 0.6, x: 0 }}
          transition={{ duration: 0.5, delay: 0.5 }}
        />
      </svg>
    </motion.div>
  );
};

export default Logo;